import { createContext, useState, useContext } from 'react'

const INITIAL_STATE = {
    order: null,
}

export const ScreensContext = createContext()

export function ScreensProvider({ children }){
    const [ data, setData ] = useState(INITIAL_STATE)

    const cache = () => {
        try{
            let dataCache = localStorage.getItem('@data')
                dataCache = dataCache ? JSON.parse(dataCache) : {}

            setData(dataCache)
            return dataCache
        }catch(err){
            console.warn('Não foi possível obter dados do storage.', err)
        }
    }
    
    const save = (data) => {
        try{
            localStorage.setItem('@data', JSON.stringify(data))
        }catch(err){
            console.warn('Não foi possível armazenar dados no storage.', err)
        }
    }

    const setOrder = order => {
        const _data = Object.assign({}, data)
        _data.order = order
        setData(_data)
    }

    return <ScreensContext.Provider value={{ 
        data,
        setData,
        cache,
        save,

        order: data.order,
        setOrder
    }}>{children}</ScreensContext.Provider>
}

export function useScreens(){
    const context = useContext(ScreensContext)
    return context
}